<!-- 选择班级 -->
<template>
  <el-form-item>
    <template #label>
      <div class="el-form-item__label">
        <slot>
          {{ label }}
        </slot>
      </div>
    </template>
    <yx-class-selector @select="select" ref="child" @clear="clear" width="222px" :queryParams="queryParams" :displayFormat="displayFormat" />
  </el-form-item>
</template>

<script>
import { inject, ref, onMounted } from 'vue';

export default {
  kind: 'yq-班级选择',
  props: {
    // 初始值.
    value: {
      type: [Array, String, Number, Object],
      default: () => ({}),
    },
    config: {
      type: Object,
      default() {
        return {
          multiple: true,
        };
      },
    },
    label: {
      type: String,
      default: '班级：',
    },
    queryParams: {
      type: Object,
      default() {
        return {
          classStatus: 0,
        };
      },
    },
    displayFormat: Function,
  },
  setup(props) {
    const child = ref(null);
    const useQuery = inject('useQuery');

    function clear() {
      child.value.clearField();
      // eslint-disable-next-line no-use-before-define
      clazz.value = {};
    }
    function reset() {
      // eslint-disable-next-line no-use-before-define
      clazz.value = props.value;
      if (props.value.id) {
        child.value.setField(props.value.className);
      } else {
        child.value.clearField();
      }
    }
    const clazz = useQuery('class', props.value, reset);

    if (props.value.id) {
      onMounted(() => {
        child.value.setField(props.value.className);
      });
    }

    function select(obj) {
      clazz.value = obj;
    }

    return {
      select,
      child,
      clear,
    };
  },
};
</script>
